import React from "react";
import PremiumResourcePage from "../../../Components/Dashboard/PremiumResourcePage";
import DeliveryChallanUpdate from "../SalesNew/DeliveryChallanUpdate";

function DeliveryChallan({ navigation }) {
  return (
    <PremiumResourcePage
      navigation={navigation}
      title="Delivery Challans"
      subtitle="Manage delivery challans and customer dispatch records."
      createRoute="DeliveryChallansNew"
      createLabel="+ New Challan"
      fetchEndpoint="/fetchDeliveryChallan"
      documentType="delivery_challan"
      deleteEndpoint="/deleteByDeliveryChallan/:id"
      deleteKey="deliveryChallan"
      renderEdit={(row, handleCancel) => (
        <DeliveryChallanUpdate
          deliveryChallan={row.deliveryChallan}
          fetchedStatus={row.status}
          handleCancel={handleCancel}
        />
      )}
      columns={[
        { key: "deliveryChallanDate", label: "Date" },
        { key: "deliveryChallan", label: "Challan #" },
        { key: "reference", label: "Reference" },
        { key: "customerName", label: "Customer Name" },
        { key: "challanType", label: "Type" },
      ]}
    />
  );
}

export default DeliveryChallan;
